import "../../styles/services.css";
import BG from "../../images/services/bg.png";
import ServicesHero from "./servicesHero";
import ServicesMain from "./servicesMain";
import ServicesFaq from "./servicesFaq";
import ServicesClients from "./servicesClients";

function Services() {
  return (
    <div>
      <ServicesHero />
      <ServicesMain />
      <img src={BG} className="services-bg-image" alt="bg" />
      <ServicesFaq />
      <ServicesClients />
    </div>
  );
}

export default Services;
